<template>
  <div class="pt-1">
    <el-row>
      {{ title }}
      <el-col :span="24">
        <div class="form-group pt-0.5">
          <el-input type="textarea" v-model="field.description" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: ['field', 'title'],
    data() {
      return {};
    },
  };
</script>

<style lang="scss"></style>
